import queryString from "query-string"
import { reportErrorMessage } from "#/utils/ErrorReporting"
import { validateUrl } from "./Regexes"
import Settings from "./CarrotConfig"

export const redirectToSamlExternalLogin = (
  externalLoginUrl: any,
  entityId: any,
  employeeIsAdmin: any,
  returnUrl?: any,
  isOpenIdFlow?: boolean
) => {
  const adminUrl = Settings.ABALONE_URL
  const redirect = (returnUrl: any) =>
    window.location.replace(
      externalLoginUrl +
        "?" +
        queryString.stringify({
          returnUrl,
          entityId
        })
    )

  if (!employeeIsAdmin && !isOpenIdFlow) {
    // handle the case where a member has attempted to access some path like
    // app.get-carrot.com/reimbursements. Since our app will show the login
    // screen, but keep the path the same, we can simply use window.location
    // and they will be properly redirected after authentication
    // OpenId logins are the exception. They must always redirect to complete the login process.
    redirect(window.location)
    return
  }

  const returnUrlFromQueryParam = returnUrl
  if (!returnUrlFromQueryParam) {
    redirect(adminUrl)
    return
  }

  const returnUrlIsAllowed = validateUrl(returnUrlFromQueryParam)
  if (!returnUrlIsAllowed) {
    reportErrorMessage(`returnUrl provided at login is not allowed: ${returnUrlFromQueryParam}`)
    redirect(adminUrl)
    return
  }

  redirect(returnUrlFromQueryParam)
}

// Prelogin SSO redirect. Unlike redirectToSamlExternalLogin, it takes no isAdmin: it forwards only the explicit
// returnUrl and lets the SAML callback resolve the admin-vs-member landing server-side.
export const redirectToSamlExternalLoginServerResolved = (
  externalLoginUrl: string,
  entityId: string,
  returnUrl?: string | null
) => {
  let allowedReturnUrl: string | undefined
  if (returnUrl) {
    if (validateUrl(returnUrl)) {
      allowedReturnUrl = returnUrl
    } else {
      reportErrorMessage(`returnUrl provided at login is not allowed: ${returnUrl}`)
    }
  }
  window.location.replace(externalLoginUrl + "?" + queryString.stringify({ returnUrl: allowedReturnUrl, entityId }))
}
